import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20product%20discovery%20flatlay%20with%20fashion%20accessories%20sneakers%20and%20textiles%20on%20soft%20cream%20linen%20surface%2C%20gentle%20golden%20hour%20natural%20lighting%20creating%20soft%20shadows%2C%20neutral%20warm%20earthy%20tones%20with%20subtle%20terracotta%20and%20sage%20green%20accents%2C%20clean%20editorial%20photography%20with%20airy%20fresh%20atmosphere%2C%20organized%20product%20display%20with%20organic%20texture%20and%20dried%20flower%20elements%2C%20aspirational%20shopping%20lifestyle%20aesthetic&width=1600&height=700&seq=cta-v2-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet shopping guide"
          className="w-full h-full object-cover object-top"
          title="Sugargoo Spreadsheet - Complete Shopping Guide"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="lg:w-3/5 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
              Ready to Master Your Sugargoo Shopping?
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg leading-relaxed">
              Dive into our complete guide covering everything from finding the best products to saving on shipping. Built for beginners and experienced shoppers alike.
            </p>
          </div>
          <div className="lg:w-2/5 flex flex-col sm:flex-row lg:flex-col items-center gap-3">
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="w-full sm:w-auto lg:w-full bg-primary-500 text-background-50 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all text-center whitespace-nowrap"
            >
              Read Complete Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto lg:w-full border-2 border-background-50/50 text-background-50 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-background-50/10 transition-all text-center whitespace-nowrap"
            >
              Visit Main Platform
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}